export class ProductsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listProdutos(filter) {
    return this.instance.get('/v1/produtos', {
      params: filter || null,
    });
  }
}

export default ProductsFactory;
